
import {throwError as observableThrowError, Observable} from 'rxjs';

import {catchError, map} from 'rxjs/operators';
/**
 * Service AuthService
 */
import {Injectable} from '@angular/core';
import {HttpHeaders} from '@angular/common/http';

import {HttpClientService} from './httpClient.service';

@Injectable()
export class MessageService {
  private _baseURL = "/api/messages/";

  constructor(private _http:HttpClientService) {
  }

  sendMail(data) {
    let url = this._baseURL + 'mail';
    let headers = new HttpHeaders({'Content-Type': 'application/json'});

    //noinspection TypeScriptValidateTypes
    return this._http.post(url, JSON.stringify(data), headers)/*.subscribe(
      res => res, err => this._handleError(err))*/
  }

  addContractorMessage(fileId, token, content) {
    let url = this._baseURL + 'file/' + fileId + '/' + token;
    let headers = new HttpHeaders({'Content-Type': 'application/json'});

    //noinspection TypeScriptValidateTypes
    return this._http.post(url, JSON.stringify({content: content}), headers);/*.subscribe(
      res => res, err => this._handleError(err))*/
  }

  addOwnerMessage(fileId, content) {
    let url = this._baseURL + 'file/' + fileId;
    let headers = new HttpHeaders({'Content-Type': 'application/json'});

    //noinspection TypeScriptValidateTypes
    return this._http.post(url, JSON.stringify({content: content}), headers)/*.subscribe(
      res => res, err => this._handleError(err))*/
  }

  getContractorFileMessages(fileId, token) {
    let url = this._baseURL + 'file/' + fileId + '/' + token;

    //noinspection TypeScriptValidateTypes
    return this._http.get(url);/*.subscribe(
      res => res, err => this._handleError(err))*/
  }

  getOwnerFileMessages(fileId) {
    let url = this._baseURL + 'file/' + fileId;

    //noinspection TypeScriptValidateTypes
    return this._http.get(url)/*.subscribe(
      res => res, err => this._handleError(err))*/
  }


  private _handleError(error) {
    // in a real world app, we may send the error to some remote logging infrastructure
    // instead of just logging it to the console
    console.error(error);
    return observableThrowError(error['message'] || error['_body'] || 'Server error');
  }
}
